import React, { useState } from "react";
import JumboRqList from "@jumbo/components/JumboReactQuery/JumboRqList";
import JumboListToolbar from "@jumbo/components/JumboList/components/JumboListToolbar";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import { useParams } from "react-router-dom";
import ListIcon from "@mui/icons-material/List";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Item from "./Item";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import Header from "./header";
import Sidebar from "./sidebar";
import { StudentProvider, useStudentContext } from "./context";
import { useJumboTheme } from "@jumbo/hooks";
import Stack from "@mui/material/Stack";
import FolderDropdown from "./FolderDropdown";
import adminServices from "../../../services/admin-services";
import StudentForm from "./StudentForm";
import { useTranslation } from "react-i18next";
import JumboSearch from "@jumbo/components/JumboSearch/JumboSearch";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

export const ASSET_IMAGES = process.env.REACT_APP_IMAGES_PATH;

export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";

const BulkActions = () => {
  return <>Bulk Action</>;
};

const Students = () => {
  return (
    <StudentProvider>
      <InnerStudents />
    </StudentProvider>
  );
};

const InnerStudents = () => {
  const { theme } = useJumboTheme();
  const { globalState, setGlobalState } = useStudentContext();
  const { t } = useTranslation();
  const lg = useMediaQuery(theme.breakpoints.down("lg"));

  const loadStudent = async ({ queryKey }) => {
    console.log(queryKey);
    const { page, limit: size, queryParams } = queryKey[1];
    const result = await adminServices.loadStudents({
      page: page + 1,
      size,
      search: queryParams?.keywords,
    });
    console.log("queryKey", page, size, queryKey, result);
    return { students: result.students, count: result.totalRecords };
  };

  const downloadFile = async () => {
    try {
      console.log("Downloading children data...");
      const result = await adminServices.downloadChildrentData({});
      console.log("Download result:", result);
      return result;
    } catch (error) {
      console.error("Error while downloading children data:", error);
      throw error;
    }
  };

  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up("lg")]: {
            position: "sticky",
            zIndex: 5,
            top: 96,
            minHeight: "auto",
          },
          [theme.breakpoints.down("lg")]: {
            display: "none",
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: "flex-start",
        },
      },
    }),
    [theme],
  );

  const params = useParams();
  const listRef = React.useRef();

  const [refreshContactsList, setContactsListRefresh] = useState(true);
  const [selectedContacts, setSelectedContacts] = useState();

  const [view, setView] = React.useState("list");

  const [queryOptions, setQueryOptions] = React.useState({
    queryKey: "students",
    queryParams: {},
    countKey: "count",
    dataKey: "students",
  });

  /*React.useEffect(() => {
        setQueryOptions(state => ({
            ...state,
            queryParams: {...state.queryParams, category: params.category, id: params.id}
        }))
    }, [params]);

*/
  React.useEffect(() => {
    if (globalState?.refreshList) {
      listRef.current.refresh();
      setGlobalState({ ...globalState, refreshList: false });
    }
  }, [globalState]);

  const renderStudent = React.useCallback(
    (student) => {
      return <Item student={student} view={view} />;
    },
    [view],
  );

  const handleOnChange = React.useCallback((keywords) => {
    // loadStudent({})
    setQueryOptions((state) => ({
      ...state,
      queryParams: { ...state.queryParams, keywords: keywords },
    }));
  }, []);

  const handleOnChange1 = (keyword) => {
    setQueryOptions({ ...queryOptions, queryParams: { keyword } });
  };

  const handleCsvClick = async () => {
    console.log("CSV download clicked");
    await downloadFile();
  };

  return (
    <JumboContentLayout
      layoutOptions={layoutOptions}
      sidebar={<Sidebar />}
      header={
        <Header
          title={t("admin-student.title.studentTitle")}
          subheader={t("admin-student.title.studentSubheader")}
        />
      }
    >
      {lg && (
        <Stack spacing={2} direction={"row"} sx={{ mb: 3, mt: -2 }}>
          {/*<FolderDropdown/>*/}
        </Stack>
      )}

      <JumboRqList
        ref={listRef}
        wrapperComponent={Card}
        primaryKey={"studentId"}
        queryOptions={queryOptions}
        itemsPerPage={10}
        itemsPerPageOptions={[10, 15, 20]}
        renderItem={renderStudent}
        service={loadStudent}
        componentElement={"div"}
        sx={view === "grid" && { p: (theme) => theme.spacing(1, 3, 3) }}
        wrapperSx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
        toolbar={
          <JumboListToolbar
            hideItemsPerPage={false}
            bulkActions={false}
            actionTail={
              <Stack direction="row" spacing={1} alignItems="center">
                <IconButton
                  size="small"
                  aria-label="download csv"
                  onClick={handleCsvClick}
                >
                  <CloudDownloadIcon />
                </IconButton>
                <ButtonGroup
                  variant="outlined"
                  disableElevation
                  sx={{
                    "& .MuiButton-root": {
                      px: 1,
                    },
                  }}
                >
                  <Button
                    variant={view === "list" ? "contained" : "outlined"}
                    onClick={() => setView("list")}
                  >
                    <ListIcon />
                  </Button>
                  <Button
                    variant={view === "grid" ? "contained" : "outlined"}
                    onClick={() => setView("grid")}
                  >
                    <ViewComfyIcon />
                  </Button>
                </ButtonGroup>
              </Stack>
            }
          >
            <JumboSearch
              onChange={handleOnChange}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            />
          </JumboListToolbar>
        }
        view={view}
      />
      <Dialog
        open={globalState.openAddEdit}
        onClose={() =>
          setGlobalState((prev) => ({ ...prev, openAddEdit: false }))
        }
      >
        <DialogTitle>
          {t("admin-student.title.enroll")}
          <IconButton
            aria-label="close"
            onClick={() =>
              setGlobalState((prev) => ({ ...prev, openAddEdit: false }))
            }
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <StudentForm />
        </DialogContent>
      </Dialog>
    </JumboContentLayout>
  );
};

export default Students;
